import { timingSafeEqual } from "crypto";

export default class DashboardController {
    constructor(DashboardService, moment, ProfilePermissionsService, Notification, $translate, 
        ContentService, $uibModal, AccountInformationService, qrcode, loadingOverlay, $timeout) {
        this.service = DashboardService;
        this.moment = moment;
        this.permissionsService = ProfilePermissionsService;
        this.notify = Notification;
        this.trans = $translate.instant;
        this.contentService = ContentService;
        this.modal = $uibModal;
        this.accountService = AccountInformationService;
        this.qrCode = qrcode;
        this.loadingOverlay = loadingOverlay;
        this.loadingDateDelta = 0;
        this.timeout = $timeout;
    }

    $onInit() {
        this.subscriptions = [];

        const _ = this.trans;
        this.ordersTranslations = {
            APPLYDISCOUNT: "Discount",
            BILLPAYMENT: "Close Bill",
            BROKEN: "BROKEN",
            DRAWERINTERACTION: "DRAWERINTERACTION",
            INFORMATIONALORDER: "INFORMATIONALORDER",
            INVOICEPRINTED: "Bill Print",
            ITEMCANCELLATION: "Cancel Item",
            ITEMRETURN: "Return Item",
            NEWBILL: "New Bill",
            NEWORDER: "-",
            NEXTREQUESTED: "Request Next",
            OTH: "OTH",
            OTHINFO: "OTHINFO",
            PAYMENTTYPECHANGED: "Change Payment Type",
            REVERSEBYPAYMENTTYPECHANGED: "Rollback Payment Type Change",
            SEPARATION: "SEPARATION",
            TABLECANCELLATION: "Cancel Table",
            TRANSFERINFO: "TRANSFERINFO",
            TRANSFERITEMTOTABLE: "Transfer Item",
            TRANSFERTABLETOCASHIER: "Transfer Vendor",
            UNDODISCOUNT: "Rollback Discount"
        };

        this.currentProfile = this.permissionsService.getProfile();
        this.profileTimezone = this.currentProfile.account_timezone;

        this.accountClosingHour;

        this.subscriptions.push(
            this.closingHourObservable.subscribe((closingHour) => {
                const recentOrdersPermission = this.permissionsService.hasPermission('recent-orders');
                const recentSalesPermission = this.permissionsService.hasPermission('recent-sales');

                if (recentOrdersPermission || recentSalesPermission) {
                    if (closingHour && typeof closingHour === 'string') { this.accountClosingHour = closingHour; }

                    if (!this.accountClosingHour) { return; }

                    var currentDate = this.moment().tz(this.profileTimezone);
                    if (this.accountClosingHour && currentDate.hours() < Number(this.accountClosingHour.replace(':00', '')) - 1) {
                        // We're still in the previous day
                        currentDate.hours(-1);
                    }
                    currentDate = currentDate.format();
        
                    this.ordersCommands = Object.keys(this.ordersTranslations);
                    if (recentOrdersPermission) {
                        this.subscriptions.push(
                            this.service.getCashierList( currentDate)
                                .subscribe(cashiers => this.cashiers = cashiers)
                        );
                        this.loadOrders( currentDate );
                    }
                    if (recentSalesPermission) {
                        this.loadSales( currentDate );
                    }
                    var otherCurrentDate = this.moment().tz(this.profileTimezone);
                    otherCurrentDate.subtract(this.loadingDateDelta, 'days');
                    
                    this.loadInvoices( otherCurrentDate.format() );
                }
            })
        );
    }
    $onDestroy() {
        this.service.stopAllPolling();
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.stopTimeoutPromise();
    }
    
    stopTimeoutPromise() {
        if (this.timeoutPromise) {
            this.timeout.cancel(this.timeoutPromise);
            this.timeoutPromise = null;
        }

    }

    loadOrders(ordersDate) {
        this.subscriptions.push(
            this.service.getRecentOrders(
                ordersDate, this.cashierId, this.tableCode, this.widgetALimit
            ).subscribe(data => this.orders = data.orders)
        );
    }

    loadSales(salesDate, offset) {
        this.subscriptions.push(
            this.service.getRecentSales(salesDate, offset).subscribe(data => {
                this.sales = data.sales;
            })
        );
    }

    loadInvoices(salesDate, offset) {
        debugger;
        this.subscriptions.push(
            this.service.getRecentInvoices(salesDate, offset).subscribe(data => {
                this.invoices = data.sales;
            })
        );
    }

    reapplyFirstWidgetFilters() {
        if (this.filterBy === 'B') {
            this.tableCode = this.tableCode || undefined;
            this.cashierId = undefined;          
        } else if (!Number.isNaN(parseInt(this.filterBy))) {
            this.cashierId = this.filterBy;
            this.tableCode = undefined;
        } else {
            this.tableCode = undefined;
        }

        var currentDate = this.moment().tz(this.profileTimezone);
        if (this.accountClosingHour && currentDate.hours() < Number(this.accountClosingHour.replace(':00', '')) - 1) {
            // We're still in the previous day
            currentDate.hours(-1);
        }
        currentDate = currentDate.format();
        this.loadOrders(currentDate);
    }

    reapplySecondWidgetFilters() {
        var salesDate = this.moment().tz(this.profileTimezone),
            offset;

        if (this.salesSince == 'today') {
            offset = undefined;
        }
        else if (this.salesSince == 'yesterday') {
            salesDate.subtract(1, 'days');
            offset = undefined;
        }
        else if (!Number.isNaN(parseInt(this.salesSince))) {
            offset = this.salesSince;
        }
        this.loadSales(salesDate.format(), offset);
    }

    dangerousRows(desc) {
        var dangerous = ['BILLPAYMENT', 'APPLYDISCOUNT'];
        return dangerous.indexOf(desc) > -1;
    }

    showElectronicOption(invoiceId) {
        this.service.stopAllPolling();
        var that = this;
        this.loadingOverlay.show();
        this.modalOpen = true;
        var hasBillsPermission = that.permissionsService.hasPermission('account-bills');
        if (hasBillsPermission ){

            this.subscriptions.push(
                this.contentService.getInvoice(invoiceId).subscribe(
                    (invoice) => {
                        //Start of modal
                        debugger;
                        this.modal.open({
                            animation: true,
                            size: 'lg',
                            templateUrl: 'invoice-details-template.html',
                            appendClassName: 'ngdialog-theme-plain',
                            controller: ($scope, $uibModalInstance, AccountInformationService, $loadingOverlay) => {
                            "ngInject";
                            
                            $scope.invoice = invoice;
                            $scope.getVatinfo = (vatNumber) => {
                                console.log('Getting vat info')
                                that.subscriptions.push(
                                    that.contentService.getVatNumberData(
                                        vatNumber ).subscribe(
                                            (data) => {
                                                $scope.invoice.name = data.vatinfo.name;
                                            },
                                            (error) => console.log("Error while getting the vat info")
                                    )
                                );
                            };
                            // $scope.invoice = {};
                            // $scope.orders = [];
                            $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
                            

                            $scope.printToCart = (printSectionId, ncfType) => {
                                
                                var invoice = $scope.invoice;
                                var rcnErrors = that.rncErrors(invoice.rnc);
                                var ncfErrors = that.ncfErrors(invoice.ncf);
                                if (!ncfType){
                                    ncfType = "E32";
                                }
                                debugger;
                                if (!( rcnErrors &&  ncfErrors)){
                                    that.subscriptions.push(
                                        that.contentService.createElectronicInvoice(invoiceId, invoice.rnc, ncfType).subscribe(
                                         (data) => {
                                             if (!data.errors){
                                                 invoice.signatureInfo = data;
                                                invoice.rnc_errors = "";
                                                invoice.ncf_errors = "";
                                                that.qrCode.toDataURL(data.qr_url).then( url => {
                                                    invoice.qrcode = url;
                                                    const img = new Image();
                                                    img.src = url;
                                                    debugger;
                                                     
                                                 }).catch( err => {console.log(err)});
                                            } else {
                                                invoice.rnc_errors = data.errors;
                                                invoice.ncf_errors = data.errors;
                                                alert( data.errors);
                                            }
                                         },
                                         (error) => {
                                            debugger;
                                            console.log(error)
                                         } 
                                        )
                                    );
                                    
                                    that.timeoutPromise = that.timeout(function(){ 
                                        console.log("Wait image to load");

                                        that.subscriptions.push(
                                            AccountInformationService.getAccountInfo().subscribe(
                                            (resp) => {
                                                if (!$scope.invoice.rnc_errors) {
                                                    debugger;
                                                    $scope.account = resp;
                                                    var innerContents = document.getElementById(printSectionId).innerHTML;
                                                    var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                                                    popupWinindow.document.open();
                                                    const styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();            
                                                    const styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
                                                    popupWinindow.document.write(`<html><head><title>Imprimir factura #${$scope.invoice.number}</title><style>${styleprint.innerHTML}</style><style>${styleprintBootstrap.innerHTML}</style></head><body class="printerBody" onload="window.print(); window.close()">${innerContents}</html>`);
                                                    popupWinindow.document.close();
                                                    that.stopTimeoutPromise();
                                                }
                                            }
                                            )
                                        )
                                    }, 2000);
                
                                } else {
                                    invoice.rnc_errors = rcnErrors;
                                    invoice.ncf_errors = ncfErrors;
                                }
                            };
                
                            $scope.closeThisDialog = () => { 
                                console.log('Reactivate Pollers');
                                debugger;
                                var currentDate = this.moment().tz(this.profileTimezone);
                                var otherCurrentDate = this.moment().tz(this.profileTimezone);
                                otherCurrentDate.subtract(that.loadingDateDelta, 'days');
                                that.loadInvoices(otherCurrentDate.format());
                                that.loadSales(currentDate.format());
                                that.loadOrders(currentDate.format());
                                console.log('Reactivated Pollers. Ready to close');
                                $uibModalInstance.close();
                                console.log('closing modal');
                            }
                            }
                        });
                        this.loadingOverlay.hide();
                        //End of modal

                    },(error) => console.log("Error while getting the invoice")
                )
            );
            
        
        }
    }

    rncErrors(rnc) {
        return false;
    }
    ncfErrors(rnc) {
        return false;
    }
    getTotal(item) { return item.total; }

    openModalClosingHour() {
        const _ = this.trans;
        const that = this;

        this.modal.open({
            animation: true,
            size: 'lg',
            templateUrl: 'closing-hour-template.html',
            appendClassName: 'ngdialog-theme-plain',
            controller: ($scope, $state, $uibModalInstance) => {
                "ngInject";
                
                const subscription = that.contentService.getClosingHour()
                    .subscribe((hour) => $scope.hour = hour || '01:00');

                $scope.closeThisDialog = () => {
                    $uibModalInstance.close();
                    subscription.unsubscribe();
                };
                $scope.updateHour = () => {
                    that.contentService.updateClosingHour($scope.hour).subscribe(() => {
                        that.notify.success(_('El horario de ciere ha sido actualizado exitosamente.!'));
                        $scope.closeThisDialog();
                    });
                    subscription.unsubscribe();
                };
            }
        });
    }
}

DashboardController.$inject = ['DashboardService', 'moment', 'ProfilePermissionsService', 'Notification', '$translate', 'ContentService', '$uibModal', 'AccountInformationService', 'qrcode','$loadingOverlay','$timeout'];


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.controller.js